var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgScorecardBetafactor = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 10C9.00983 10 7.66669 9.01503 7.66669 7.8C7.66669 6.58497 9.00983 5.6 10.6667 5.6M10.6667 10C12.3235 10 13.6667 10.985 13.6667 12.2C13.6667 13.415 12.3235 14.4 10.6667 14.4M10.6667 10V5.6M10.6667 10L10.6667 14.4M10.6667 5.6C11.7771 5.6 12.7466 6.04242 13.2653 6.7M10.6667 5.6V4.5M10.6667 14.4L10.6667 15.5M10.6667 14.4C9.55629 14.4 8.58676 13.9576 8.06805 13.3M21.6667 21L17.0307 16.364M17.0307 16.364C15.402 17.9926 13.152 19 10.6667 19C5.69613 19 1.66669 14.9706 1.66669 10C1.66669 5.02944 5.69613 1 10.6667 1C15.6373 1 19.6667 5.02944 19.6667 10C19.6667 12.4853 18.6593 14.7353 17.0307 16.364Z",
    stroke: "#9594AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgScorecardBetafactor, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/scorecard-betafactor.dbd1e65c.svg";
export { ForwardRef as ReactComponent };